<div class="report-optimisation-overview-container">
    <slot/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .report-optimisation-overview-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: @spacing-xxl;
    }
</style>